import { useState, useEffect } from "react";

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount
  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 150),    // Big square appears
      setTimeout(() => setPhase(2), 450),    // Small square appears
      setTimeout(() => setPhase(3), 1000),   // Start fade out (stay centered)
      setTimeout(() => onComplete(), 1500),  // Complete
    ];
    return () => timers.forEach(clearTimeout);
  }, [onComplete]);

  // Get position styles - always centered, fade out in place
  const getContainerStyle = () => {
    return {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) scale(1)',
    };
  };

  return (
    <div 
      className={`fixed inset-0 z-[9999] bg-white transition-opacity duration-500 ${
        phase >= 3 ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Container that holds both squares - stays centered, fades out */}
      <div 
        className="fixed transition-all duration-500 ease-in-out"
        style={getContainerStyle()}
      >
        {/* Layout: Big square TOP-RIGHT, Small square BOTTOM-LEFT */}
        {/* Mobile: smaller, Desktop: original sizes */}
        <div 
          className="relative"
          style={{ 
            width: isMobile ? '100px' : '140px', 
            height: isMobile ? '100px' : '140px' 
          }}
        >
          {/* Big square - TOP RIGHT */}
          <div
            className={`absolute bg-[#00A19A] transition-all duration-500 ease-out ${
              phase >= 1 ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
            }`}
            style={{
              width: isMobile ? '60px' : '80px',
              height: isMobile ? '60px' : '80px',
              top: '0px',
              right: '0px',
            }}
          />
          
          {/* Small square - BOTTOM LEFT */}
          <div
            className={`absolute bg-[#00A19A] transition-all duration-500 ease-out ${
              phase >= 2 ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
            }`}
            style={{
              width: isMobile ? '36px' : '48px',
              height: isMobile ? '36px' : '48px',
              bottom: '0px',
              left: '0px',
            }}
          />
        </div>
      </div>
    </div>
  );
}
